export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div>© {new Date().getFullYear()} Systematix. All rights reserved.</div>
      </div>
    </footer>
  );
}
